export const RO_MANAGE_AMBASSADOR = `/ambassadors`;
export const RO_WEBINAR = `/webinar`;
